import React, { lazy, Suspense } from 'react';
import $ from 'jquery';

import { Router, Route, Switch, withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import cookie from 'react-cookies';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import ReactGA from 'react-ga';
import { Provider, connect } from "react-redux";
import { legacy_createStore as createStore } from 'redux'
import reducer, { StoreUserData, StoreUser, StoreMasterData, StoreAuthToken } from "./DataStore";
import Home from "./home.js";
import ErrorBoundary from "./ErrorBoundary";
import PageVisibility from 'react-page-visibility';
//import * as Sentry from "@sentry/react";
import LoadingPlaceHolder from './RLoadingPlaceHolder';
import { MakeSocketConnection, SocketSync, UpdateUserDataInCacheDBSocket,getDecompressedData, UpdateDangDataInCacheDBSocket, MirraclesSync } from './SocketAPI';
import { AreYouIOS, showConfirmBoxWithCancel, ProcessUserData, SaveExceptionToSentry, SaveCleintWaufli,TableLastSyncDateTime,GetDataByType,GetNotificationRedirect, showLockedBox } from "./RUtility";
const OverlayComponenet = lazy(() => import('./OverlayComponent'));
const SecondOverlayComponent = lazy(() => import('./SecondOverlayComponent'));
const EpassOverlayComponent = lazy(() => import('./epassOverlayComponent'));



const SignUp = lazy(() => import('./signup'));
const GuestHandlerCompenent = lazy(() => import('./GuestHandler'));

// Sentry.init({
//     dsn: "https://5171bd53a2df4771c96353c6a478c5c9@o954215.ingest.sentry.io/4505963651727360",
//     integrations: [
//       new Sentry.BrowserTracing({
//         // See docs for support of different versions of variation of react router
//         // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
//         routingInstrumentation: Sentry.reactRouterV6Instrumentation(
//           React.useEffect,
//         //   useLocation,
//         //   useNavigationType,
//         //   createRoutesFromChildren,
//         //   matchRoutes
//         ),
//       }),
//       new Sentry.Replay()
//     ],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     tracesSampleRate: 1.0,

//     // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//   });


const C404 = lazy(() => import('./404'));

const dataStore = createStore(reducer);



window.historyInstance = createBrowserHistory();
//import { Provider } from "react-redux";
//import { createStore } from "redux";
//import reducer from "./DataStore";
//import reduxExample from "./ReduxExample";
//import ScrollRestoration from 'react-scroll-restoration'
//const vehicle = createStore(reducer);

//var newTimeout = 3000;

// const transitionStyles = {
//     entering: { opacity: 1 },
//     entered: { opacity: 1 },
//     exiting: { opacity: 0 },
//     exited: { opacity: 0 },
// };

const AnimatedSwitch = withRouter(({ location }) => (
    <TransitionGroup>
        <CSSTransition key={location.key} classNames="slide" timeout={{

            enter: 1,
            exit: 250,
        }} >
            <Switch location={location} >

                <Route path={["/certifications","/abilityskillcard","/organscategory","/organs","/inclusiveinsights","/zone/:name","/credit-statement","/kids-parents","/staff","/parentenrollment","/kidprogress","/leavedetails","/allkidsprogress","/therapyslots","/therapyserviceletter","/fulfillmentclarity","/therapeuticairemote","/familyincentiveinsight","/familyinsight","/deputations","/incentivebenifit","/incentivecontribution","/pinnaclefamilyincentivespossibilities/:id","/inclusiveleaderscategories","/newmore","/inclusivedashboard","/allpollination","/pinnacleclarity","/hyperactions/:id","/hppartner/:id","/hyperlocal","/incentivedetais","/vieweipreport","/pollination","/viewgoal","/viewalleips","/pinnacletv","/askai","/planet-autism","/planetautismpreview","/sendmessageedition","/addhomework","/bookedassessments","/aigoalnotset","/completedhomework","/parenthomeworkpending","/aipendingattendance","/therapeutichomework","/viewhomework","/demographicentitydetails","/demographicai","/demographicdetails","/viewaigoal","/googlegpt","/readinessindex","/therapysession","/goalsuggestion","/milestone","/viewmilestone","/viewtherapeuticassessments","/createeip","/eipreport","/hellopinnacle","/aigenerator","/pinnacleai", "/attendancesheet","/biometricrepo", "/magicpinnacle","/globalinnovation","/aiinnovations","/psychology-consultation", "/vpi", "/pinnacleperks","/employeedetail","/bodyrecognition", "/wip", "/idcard", "/pdfviewer", "/pinnacleip", "/cart", "/kidstatetracker", "/s/", "/changecoverphoto", "/fcrc", "/BBP","/devices", "/kidstate", "/gptcategory", "/pendingsgpt", "/policiesgpt", "/opencreations", "/sendmessagetotelegram", "/categories", "/d/r", "/people", "/search", "/compensation", "/notifications", "/hanuman", "/hanuman:id", "/createexpense", "/createparent", "/trumpet", "/publishscreen", "/serviceland", "/createservice", "/createstaff", "/createlead", "/leaverequest", "/guru/:id", "/guru/name/:id", "/services/:id", "/assessment/:id", "/usercard", "/usercard/:id","/usercard/:id/:role","/biometricdetails", "/blackbox", "/changemobilenumber", "/profile", "/privacypolicy", "/faq", "/contactus", "/termsofuse", "/refundpolicy", "/career", "/cookiepolicy", "/AdvancedInvoices", "/allinvoices", "/wallet", "/sanjeevani", "/dietplan", "/pranayamas", "/meditation", "/subscription", "/testimonial", "/referral", "/team", "/vision", "/mission", "/media-coverage", "/kotiigroup", "/bhclpl", "/values", "/innovation", "/package", "/profiles", "/lifestyles", "/consultations", "/healthconditions", "/rconsultations", "/assessments", "/parameters", "/deactivation", "/seemore", "/feedback", "/offers", "/favorites", "/bookmarks", "/attendance", "/payment", "/maddress", "/o/:id", "/po/:id", "/aboutus", "/pd/completedorders", "/attendancekpi", "/serviceskpi", "/goalskpi", "/assessmentskpi", "/bookassessment","/manualbioentry", "/mirraclesreport", "/mirraclesassigned", "/mirraclesconfig", "/allawards", "/allmemos", "/pendinginvoices", "/hermes", "/goalsetting", "/createinvoice", "/updateinvoice", "/pti", "/touchbase", "/forcelogoff", "/microphoneguide", "/payments", "/nuture", "/kubera", "/kpireport", "/bossreceipts", "/mirraclebypinnacle", "/mirracles", "/pinnacleidcard", "/allcertificates", "/talentacquisition", "/royalty", "/immediate","/contributions", "/bankdetails", "/pfdetails", "/genericreports", "/allservicerequests", "/recents", "/allparentleaves", "/alltherapistleaves", "/roffers", "/allcompensations", "/payslip", "/salarystatement", "/basicdetails", "/cleaves", "/leaveapprovals", "/availableslots", "/dangkpi", "/mirracletopbanner", "/personaltelegram","/prosuggestions", "/therapistleaverequest","/adminleaverequest","/blueforceleaverequest", "/centerdetails", "/centerdetails/:id","/servicerequestdetails/:id", "/goal/:id", "/playground", "/servicerequest","/familyincentive"]} >
               
                    <OverlayComponenet />

                </Route>




                <Route path={["/guesthandler"]} >

                    <GuestHandlerCompenent />

                </Route>

                <Route path={["/signup"]} >

                    <SignUp />

                </Route>

                <Route path={["/epass", "/validate-otp"]} >
                    <EpassOverlayComponent />
                </Route>


                <Route path={["/", "/home", "/more", "/updates", "/d", "/d/ff", "/d/o", "/autismgpt"]}>
                </Route>

                <Route path={["*"]}>
                    <C404 />
                </Route>
            </Switch>
        </CSSTransition>

    </TransitionGroup>
));
export const updateUserDataInCacheDB = (result, callback) => {
    UpdateUserDataInCacheDBSocket(result, callback);
}

export const updateDangDataInCacheDB = (result, callback) => {
    UpdateDangDataInCacheDBSocket(result, callback);
}

export const updateMasterDataInLocalStorage = (result) => {

    // UpdateMasterDataInLocalStorage(result);
}

///
export const DispatchFromAppJs = (data, user) => {
    try {
        console.log("Dispatch Called ");

        dataStore.dispatch(StoreUserData(data));

        if (user) {
            dataStore.dispatch(StoreUser(JSON.parse(JSON.stringify(user))));
        } else {
            console.log("DispatchFromAppJs Warning: user is undefined");
        }
        //dataStore.dispatch(StoreUser(JSON.parse(JSON.stringify(user))));

        console.log("AFTER Dispatch");
    }
    catch (e) {
        //console.log(e);
        SaveCleintWaufli(e, "DispatchFromAppJs Failed ", "app.js");
    }
}

let onlyOnce = false;

let apiCacheName = 'APICACHE';
var currentPersonInLocal;
class App extends React.Component {
    constructor(props) {
        super(props);

        if (onlyOnce) return;

        var appConstructorStartDateTime = new Date();
        var isNotificationPage = false;

        console.log("App Constructor Start :" + appConstructorStartDateTime);
        // KOTI :: localStorage.setItem("UsageType", "1");


        // KOTI

        // var currentUrl = window.location.pathname;
        // if (window.historyInstance.length == 0 && window.location.href != "/d" && window.location.href != "/epass" && window.location.href != "/") {
        //     window.historyInstance.push("/d");
        //     window.historyInstance.push(currentUrl);
        // }


        this.user = localStorage.getItem("UserData");

        if (!this.user && !getFromCookie("UserData")) {
            this.user = getFromCookie("UserData");
        }
       

        var authToken = getUserToken();
        if (!authToken) {
            //HANDLE LANDING URL SCENARIO. ADD ACTUAL URL TO NAVIGATION     
            var navigationURL = (window.location.pathname.indexOf("epass") > -1 || window.location.pathname.indexOf("navigateTo") > -1 ) ? "" : "?navigateTo=" + encodeURIComponent(window.location.href);       
            var ePassURL = ("/epass" + (navigationURL ? navigationURL : ""));
            if(window.location.pathname.indexOf("epass") > -1 ){
                var purl = new URL(window.location.href);
                var ctValue = purl.searchParams.get("ct");
                var naviUrl = purl.searchParams.get("navigateTo");
                if(ctValue){
                    sessionStorage.setItem("ct", ctValue);
                }
                
                if(naviUrl){
                    window.historyInstance.push("/epass" +(naviUrl ? "?navigateTo=" + naviUrl : ""));
                }
                else{
                    window.historyInstance.push("/epass" +(ctValue ? "?ct=" + ctValue : ""));
                }
            }
            else{
                window.historyInstance.push(ePassURL);
            }
           
            return;
        }
       
        this.currentPersonDetails = JSON.parse(localStorage.getItem("UserData"));
        dataStore.dispatch(StoreUser(this.currentPersonDetails));
        if (window.location.href.indexOf("/mirracles") == -1) {

            // window.historyInstance.push("/mirracles");
            // window.historyInstance.push("/mirracles");


            if (this.currentPersonDetails && this.currentPersonDetails.F11 != "YES") {

            }
            else if (this.currentPersonDetails && !this.currentPersonDetails.F15) {
                showConfirmBoxWithCancel("Joyful, Useful, Learning Empowerment from Certified, Qualified, Expert Therapists.", "Pinnacle Mirracles : Kids Wonderful LIFE", "Show Pinnacle Mirracles{#}Go to Dashboard", false, function (data) {
                    if (!data) {
                        window.historyInstance.go(-1);
                    }
                });
            }

        }
        if (authToken && window.location.pathname.indexOf("epass") > -1) {
            var purl = new URL(window.location.href);
            var ctValue = purl.searchParams.get("ct");
            var naviUrl = purl.searchParams.get("navigateTo");
           
            if(ctValue){
                sessionStorage.setItem("ct", ctValue);
            }

            if(naviUrl){
                window.location.href = naviUrl;
            }
            else{
                window.historyInstance.push("/d" +(ctValue ? "?ct=" + ctValue : ""));
            }
            
        }
        dataStore.dispatch(StoreAuthToken(authToken));

        /* KOTI :: START THIS BLOCK IS NOT BEING OF USE - CONSUME MASTER FROM SINGLE DATA UNIT*/
        // var response = localStorage.getItem("MasterData");
        // if (response) {
        //     var repos = JSON.parse(response);

        //     this.state = { MasterData: repos, UserData: {} };

        //     if (currentPersonInLocal) {
        //         //  this.state = { IsDataLoaded: true, MSD: repos.MasterData, GL: repos.GList, US: repos.USettings, CartCount: 0, currentPersonDetails: currentPersonInLocal, DashboardUserDataList: [], FamilyMembersDataObj: [] };
        //         this.state = { IsDataLoaded: true, MasterData: repos, currentPersonDetails: currentPersonInLocal };
        //     }
        //     else {
        //         this.state = { IsDataLoaded: true, MasterData: repos, UserData: {} };
        //     }


        //     dataStore.dispatch(StoreMasterData(repos));
        // }
        // else
        // {
        //     // ?
        // }
        /* KOTI :: END TILL HERE */

        var currentUser = this.currentPersonDetails;

        var dataExists = false;
        ///GET NH VALUE
        var parameterUrl = new URL(window.location.href);
        var nhValue = parameterUrl.searchParams.get("l");
        var ctValue = parameterUrl.searchParams.get("ct");
        if(ctValue){
            sessionStorage.setItem("ct", ctValue);
        }
        ///TEMPORAY CHECK FOR NH URLS
        if(!nhValue){
            nhValue = parameterUrl.searchParams.get("nh");
        }

        try {

            var date1 = new Date();
            console.log("Cache about to be opened:" + (appConstructorStartDateTime - date1));

           caches.open(apiCacheName).then(cache => {
            
                console.log("#1. Connection Open:" + (new Date() - date1));
                window.globalCacheInstance = cache;
                cache.match("/PSUserData").then(async userDataResponse => {

                    getDecompressedData(userDataResponse).then(async dataFromM =>{

                        try {
                            console.log("#2. Acquired User Data:" + (new Date() - date1));
    
                            //userDataResponse =  dataFromM;
                           // console.log(userDataResponse);
                            //CALCULATE THE STORGE 
    
                            try {
                                navigator.storage.estimate().then(({ usage, quota }) => {
                                    var usagePercentage = ((usage / quota) * 100);
                                    console.log("Storage Manager Usage :" + usagePercentage + "%");
    
                                    try {
                                        if (usagePercentage >= 70) {
    
                                            var exceptionMessage = "Quota: " + quota + " Used: " + usage + " Percentage: " + usagePercentage + "%, Code: " + (currentUser.Code ? currentUser.Code : currentUser.Id) + "\n\nName:" + currentUser.Name + "\n\n" + "Handle:" + currentUser.Handle + ",\n\nBrowser Agent:" + navigator.userAgent;
                                            var exception = {};
                                            exception.Type = "LOWMEMORYDEVICES";
                                            exception.Message = exceptionMessage;
                                            SaveExceptionToSentry(exception, "Error", getUserToken(), "LOWMEMORYDEVICES");
    
                                        }
                                    }
                                    catch (e) {
                                        console.log("Error IN Low Memory device log", e)
                                    }
    
                                });
                            }
                            catch (e) {
                                console.log("Storage Estimation Error", e)
                            }
                            var resultObj = null;
                          //  console.log("response: ", userDataResponse);
                            if (dataFromM) {
    
    
    
    
                                //var results = JSON.parse(userDataResponse.text());
                                //   console.log("#2. Data Parsed :"+ (new Date() - date1));
                                // console.log("resultObj",results);
                                 resultObj = JSON.parse(dataFromM);// JSON.parse(await userDataResponse.text());
                                dataExists = true;
                                // window.localCacheData = resultObj;
                                //console.log("resultObj");
                                // console.log("#3. UserData JSON :" + (new Date() - date1));
    
    
    
                                //CALCULATE THE STORAGE NO NEED TO ANY
                                try {
                                    // console.log("VISUALIZE LOCAL DATA")
                                    // console.log("Entity,STDate,EnDate,Count,Size,JulyLength,JulySize");
                                    var dateCurrent = new Date();
                                    var firstDay = new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), 1);
                                    Object.keys(resultObj).forEach((key, index) => {
    
                                        try {
                                            if (resultObj[key].length > 0) {
                                                var data = resultObj[key];
                                                //console.log(key);
                                                if (key == 'LastSyncDataTime') {
                                                    return;
                                                }
                                                let combinedDates = data.reduce((acc, obj) => { acc.push(obj.CDT); return acc; }, []);
    
                                                //console.log("GETHIGHEST COMBINED FOR " + type);
    
                                                // let dateToReturn =  new Date(Math.max.apply(null, combinedDates.map(function (e) {return new Date(e);})));
    
                                                let sortByDescending = combinedDates.map(function (e) { return new Date(e); }).sort(function (a, b) { return a > b ? -1 : 1 })[0];
                                                let sortByAscending = combinedDates.map(function (e) { return new Date(e); }).sort(function (a, b) { return a > b ? 1 : -1 })[0];
                                                var size = (JSON.stringify(data).length / (1024 * 1024)).toFixed(2);
    
                                                var julyData = data.filter(t => new Date(t.CDT) >= firstDay);
                                                if (key == "Fee") {
                                                    julyData = data.filter(t => new Date(t.CDT) >= firstDay || new Date(t.FDT) >= firstDay);
                                                }
                                                var sizeForJuly = (JSON.stringify(julyData).length / (1024 * 1024)).toFixed(2);
    
                                                //console.log(key + "," + sortByDescending.toLocaleDateString() + "," + sortByAscending.toLocaleDateString() + "," + data.length + "," + size + "," + julyData.length + "," + sizeForJuly);
                                                //     //console.log(TableLastSyncDateTime[key]);
                                                //    // console.log(result[key]);
                                                //     if(TableLastSyncDateTime[key]){
                                                //         SetLocalStorage(TableLastSyncDateTime[key], GetHighestCDTorUDT(result[key],key));
                                                //     }
                                            }
                                        }
                                        catch (e) {
                                            console.log("Size Error for " + key);
                                            return;
                                        }
    
    
                                    });
                                }
                                catch (e) {
                                    console.log("ERROR IN LOCAL DATA SIZE CALCULATION", e);
                                }
    
    
                                ProcessUserData(resultObj, dataStore, null);
                                //  dataStore.dispatch(StoreUserData(resultObj));
                                //console.log("#4. User data in Rect Store:" + (new Date() - date1));
    
                                if (resultObj && resultObj.UserSettings && AreYouIOS()) {
                                    var d = $.grep(resultObj.UserSettings, function (e) {
    
                                        return e.Name == "IOSSETTINGSNATIVEENABLE"
                                    })[0];
    
                                    if (d) {
                                        window.location.href = "mirraclescheme://permissions?" + d.Value.replace("&amp;", "&");
                                    }
                                }
    
                                //  KOTI :: START SYNC CALL.
                                //     MakeSocketConnection(authToken, dataStore, function (res) {
                                //         console.log("WebSocket Connection Established Successfully.");
                                //         console.log(new Date());
                                //         SocketSync(0, function (data) {
                                //             // console.log(data);
                                //             console.log("After Sync");
                                //             console.log(new Date());
                                //         });
                                // // KOTI :: END SYNC CALL.
                                //     });
    
                            }
                            // else {
    
                           
    
                            //SOURABH :: CHECK LOCAL DATA and LS KEY, IF LS KEY AND NO CACHE DATA FULL SYNC
                            //REMOVING LAST SYNC DATE TIME FOR INITIATING FULL SYNC
                            var lsSyncData = localStorage.getItem("LastPSSyncDataTime");
                            if (!userDataResponse && lsSyncData) {
                                localStorage.removeItem("LastPSSyncDataTime");
    
                                //REMOVE ALL LOCAL TABLE KEYS
                                Object.keys(TableLastSyncDateTime).forEach((key, index) => {
                                    localStorage.removeItem(TableLastSyncDateTime[key]);
                                });
                            }
                               
                            if (nhValue) {
                                this.isNotificationPage = true;
                               await notificationHandler(nhValue,resultObj,authToken, dataStore, currentUser);
                                
                            }
                            else {
                                this.isNotificationPage = false;
                                //  KOTI :: START SYNC CALL.
                                MakeSocketConnection(authToken, dataStore, function (res) {
                                    // console.log("WebSocket Connection Established Successfully.");
                                    // console.log(new Date());
                                    SocketSync(0, function (data) {
                                        // console.log(data);
                                        // console.log("After Sync");
                                        // console.log(new Date());
                                    });
                                    // KOTI :: END SYNC CALL.
                                });
    
                            }
    
                           
    
                            //  }
                        }
                        catch (e) {
                            SaveExceptionToSentry(e, "Error", getUserToken(), "APP-CACHE-STORE");
                        }
                    });
                  
                });
            });


        } catch (e) {
            SaveCleintWaufli(e, "Cache failed", " app.js");
            SaveExceptionToSentry(e, "Error", getUserToken(), "APPJS - CONSTRUCTOR");
            console.error("App Constructor Error" + e);
        }

        //console.log("App Constructor End:" + (new Date() - appConstructorStartDateTime));
        onlyOnce = true;

    }



    handleVisibilityChange = isVisible => {
        if (isVisible) {
            console.log("ENTERED INTO FOCUS");
            try {
                // console.log("Is Screen Visible : " + isVisible);
                var authToken = getUserToken();
                if (isVisible && authToken) {

                    //  KOTI :: START SYNC CALL.
                    // MakeSocketConnection(authToken, dataStore, function (res) {
                    //     console.log("WebSocket Connection Established Successfully.");
                    //     console.log(new Date());
                    //     SocketSync(0, function (data) {
                    //         // console.log(data);
                    //         console.log("After Sync");
                    //         console.log(new Date());
                    //     });
                    //     // KOTI :: END SYNC CALL.
                    // });


                }
            } catch (err) {
                console.log("Error in handleVisibilityChange :: " + err);
            }
        }
    }
    //VerifyRoyaltyPayment = function () {
    //    if (this.props.userData && this.props.userData.FData) {
    //        var data = $.grep(this.props.userData.FData, function (e) { return e.AT == "ROYALTY" })[0];
    //        var $this = this;
    //        if (data) {
    //            showConfirmBoxWithCancel("", "Please do clear royalty amount", "Cleared Already", false, function (data) {

    //                    window.historyInstance.go(-1);

    //            });
    //        }
    //    }
    //}
    //componentDidUpdate(prevProps, prevState, snapshot) {

    //    //console.log(url);

    //    if (this.props && this.props != prevProps && this.props.userData && this.props.userData.FData) {
    //        //console.log("ENTERED");

    //        this.VerifyRoyaltyPayment();

    //    }
    //    //console.log("====DIDComponenet==");
    //}

    //<ScrollRestoration />

    render() {
        return <Provider store={dataStore}>
            <Router history={window.historyInstance}>
                <ErrorBoundary>
                    <PageVisibility onChange={this.handleVisibilityChange} >
                        <Home IsNP={this.isNotificationPage} />
                    </PageVisibility>


                    <Suspense fallback={<LoadingPlaceHolder IsPageLoaderReqired={true} Height="1000px" />}>

                        <AnimatedSwitch />

                    </Suspense>
                </ErrorBoundary>
            </Router>
        </Provider>

    }
}
const mapStateToProps = state => {
    return {
        // To get the list of employee details from store
        userData: state.UD,
        MasterData: state.MD
        
    }
};

export default connect(mapStateToProps, null)(App)

export function getStore() {
    return dataStore;
}


function showConfirmBoxWithCancel3(message, header1, buttonvalue, isItError, callback) {
    try {

       // alert("Called");
        setTimeout(function () {
            //$('html, body').addClass('popUpBackround');
        }, 20);
        if (message == "DONTSHOWCONFIRMATIONBOX") {
            callback(false);
            return;
        }

        if ("whatsappmessagescreen" == header1) {
            $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass('whatsappmessage');
        }

        var header = header1 ? (header1.split("{#}").length > 1 ? header1.split("{#}")[0] : header1) : "Error";


        var textToDisplay = header1 ? (header1.split("{#}").length > 1 ? header1.split("{#}")[1] : header1) : "Error";
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations #alert-success-confirm-overlay-header').html(textToDisplay);

        var okbuttonName = buttonvalue ? buttonvalue.split("{#}")[0] ? buttonvalue.split("{#}")[0] : "Okay" : "Okay";
        var cancelbuttonName = buttonvalue ? buttonvalue.split("{#}")[1] ? buttonvalue.split("{#}")[1] : "Remove" : "Cancel";


        var imageUrl = header.toLowerCase() == "alert" || header.toLowerCase() == "info" || header.toLowerCase() == "validation" || header == "Rember, It is all about a kids future, 6 families lifes " ? "/images/alert.png" : header.toLowerCase() == "warning" || header.toLowerCase() == "confirmation" ? "/images/warning.png" : (header.toLowerCase() == "success" || header.toLowerCase() == "pinnacle mirracles : kids wonderful life") ? "/images/Success.jpg" : "/images/error.png";

        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations .asco-img").attr("src", imageUrl);

        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value="ok"]').val(okbuttonName);
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").val(cancelbuttonName);

        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .alert-header').html(message);
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('close');
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('open');
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").show();
        if (cancelbuttonName == "Remove") {
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").hide();
        }
        $('.alert-success-confirm-overlay').show().addClass('active');
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('error');
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations svg').hide();

        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .SVU-close svg').show();
        if (isItError) {
            $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass('error');
        }

        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").click(function () {
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
            $('.alert-success-confirm-overlay').show().removeClass('active');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").unbind("click");
            //$('html, body').removeClass('popUpBackround');
            $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('whatsappmessage');
            callback(true);

        });

        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").click(function () {
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").unbind("click");
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
            $('.alert-success-confirm-overlay').show().removeClass('active');
            //$('html, body').removeClass('popUpBackround');
            $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('whatsappmessage');
            callback(false);
        });

    } catch (e) {
        console.log(e.message);
        // $('html, body').removeClass('popUpBackround');
    }
}

$(document).ready(function () {


    $(document).on("click", function (e) {
        // alert(e);

    });
    $("body").on('click', '.footerNav', function (e) {

        var type = $(this).attr('data-type');
        window.historyInstance.push("/search/" + type);
        e.preventDefault();
        e.stopPropagation();
    });

    $("body").on('click', '.footerNav22', function (e) {

        e.preventDefault();
        e.stopPropagation();
    });

    $("body").on('click', '.footerNavInnerPage22', function (e) {
        //var type = $(this).attr('data-type');
        //window.historyInstance.push("/search/" + type);
        e.preventDefault();
        e.stopPropagation();
    });


    $("body").on('click', '.footerNavInnerPage', function (e) {

        var type = $(this).attr('data-type');
        window.historyInstance.push("/m/" + type);
        e.preventDefault();
        e.stopPropagation();
    });

    $("body").on('click', '.showfaq', function (e) {

        window.historyInstance.push("/faq");
        e.preventDefault();
        e.stopPropagation();

    });

    $("body").on('click', '.privacy-policy', function (e) {

        window.historyInstance.push("/privacypolicy");
        e.preventDefault();
        e.stopPropagation();

    });

    $("body").on('click', '#close-loader-bar', function (e) {

       
        var typename = $("#noti-type").val();

        showConfirmBoxWithCancel3("Are you sure you dont want to see the notification for  " + typename, "Info", "Yes,Proceed{#}Cancel", true, function (confi) {
             if (confi) {
                $(".notification-overlay").removeClass('active');
             }
        });
       

    });

    

 
    var appType = localStorage.getItem("validatorapptype-s");
    // var url = location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const clientType = urlParams.get('ct');
    if (clientType && !appType) {
        localStorage.setItem("validatorapptype-s", clientType);

    }

    console.log(clientType);
});




async function notificationHandler(nhValue, resultObj, authToken, dataStore, currentUser) {

    try {

        ///STEP 1: GET PARAM VALUES
        const paramValues = nhValue.split('-');
        if (paramValues.length < 2) {
            console.error('Invalid notification value:', nhValue);
            return;
        }
        // var type = paramValues[0];
        // var id = paramValues[1];

        const [type, idString] = paramValues;
        const id = parseInt(idString);
        if (isNaN(id)) {
            console.error('Invalid ID in notification value:', idString);
            return;
        }
        var curUser = resultObj && resultObj.CFUser ? resultObj.CFUser : null;
        if(curUser && type && type.toLowerCase() == 'attendance'){
            if(curUser && curUser.RoleId == 29){
                showLockedBox(`As you have leadership role, this data not available for you`, "info", "ok");
                return '';
            }
            
        }

        ///STEP 2: CHECK DATA EXISTS IN LOCAL, PUSH URL IF DATA EXISTS
        var data = GetDataByType(parseInt(id), type, resultObj);
        var urltoPush = GetNotificationRedirect(id, type);
        var excluetypes=["leadingleads","irregularexpense","leadingleadsaward","leaverequest","peoplecall","abilityscorememo","abilityscoreaward","bot"]
        // if (data && urltoPush && excluetypes.indexOf(type) == -1) {
        if (urltoPush && (excluetypes.indexOf(type) > -1 || data)) {
            var message = {};
            message.Type = "NOTIFICATIONHANDLERSUCCESS";
            message.Message = "Notification Handled for url: " + window.location.href + " of " + (currentUser ? currentUser.Handle : "");
            //SaveExceptionToSentry(message, "Error", getUserToken(), "NOTIFICATIONHANDLERSUCCESS");

           
              var ctValue = sessionStorage.getItem("ct");
          
              if(ctValue){
                urltoPush = urltoPush ? urltoPush.indexOf('?') > -1 ? (urltoPush + "&ct=" + ctValue) : (urltoPush + "?ct=" +ctValue) :urltoPush;

              }
            //SET IN LOCAL STORAGE TO BE CONSUMED BY APP
            localStorage.setItem("landingurl",urltoPush);
            window.historyInstance.push(urltoPush);
            return;
        }

        ///STEP 3: CALL SYNC SHOW NH LOADER
        MakeSocketConnection(authToken, dataStore, function (res) {
            $(".notification-overlay").addClass('active');
            $("#noti-type").val(type);
            $("#notification-text").html('Getting your ' + type + 's');
            SocketSync(0, function (data) {

                console.log("After NH Sync", data);
                
                $(".notification-overlay").removeClass('active');
                ///STEP 4 :: CHECK FOR DATA IN SYNC DATA
                var data = GetDataByType(parseInt(id), type, data);
                if (data) {
                    var urltoPush = GetNotificationRedirect(id, type);

                    var message = {};
                    message.Type = "NOTIFICATIONHANDLERSUCCESS";          
                    message.Message = "Notification Handled for url: " + window.location.href  + " of " + (currentUser ? currentUser.Handle : "") ;
                    SaveExceptionToSentry(message, "Error", getUserToken(), "NOTIFICATIONHANDLERSUCCESS");

                    var ctValue = sessionStorage.getItem("ct");
          
                    if(ctValue){
                      urltoPush = urltoPush ? urltoPush.indexOf('?') > -1 ? (urltoPush + "&ct=" + ctValue) : (urltoPush + "?ct=" +ctValue) : urltoPush;
      
                    }
                     //SET IN LOCAL STORAGE TO BE CONSUMED BY APP
                    localStorage.setItem("landingurl",urltoPush);
                    window.historyInstance.push(urltoPush);
                    return;
                }
                else {
                    showLockedBox(`Your ${type} is being prepared, please retry clicking the same notification after 4 minutes`, "info", "ok");
                    var message = {};
                    message.Type = "NOTIFICATIONHANDLERDATAFAILED";          
                    message.Message = "Notification failed url: " + window.location.href  + " of " + (currentUser ? currentUser.Handle : "") ;
                    SaveExceptionToSentry(message, "Error", getUserToken(), "NOTIFICATIONHANDLERDATAFAILED");
                }


            });

        });

    }
    catch (e) {
        showLockedBox("We are unable to process your request currently, if problem persists please call NCC on 9100181181", "info", "ok");
        SaveCleintWaufli(e, "NotificationHandler Failed for " + nhValue , " app.js");
        SaveExceptionToSentry(e, "Error", getUserToken(), "NotificationHandler");
    }



}



export function UpdateUserData(result) {
    dataStore.dispatch(StoreUserData(result));
}
function getFromCookie(type) {
    try {
        var result = cookie.load(type);
        return result;
    } catch (e) {
        console.log(e);
    }
}

function getUserToken() {
    var token = ""
    try {
        token = cookie.load('validatorauth-s');

        if (!token) {
            token = localStorage.getItem("validatorauth-s");
        }
        // console.log(token);
    } catch (e) {

        console.log("error in reading token from cookie...");
        console.log(e);
        token = localStorage.getItem("validatorauth-s");
    }

    return token;
}


